import React from 'react';

import './style.scss';

const SliderArrow = ({ type, visible, onClick }) => {

  return (
    <div className={`SliderRelated__${type} ${visible ? 'SliderRelated__prev--visible' : ''}`} onClick={onClick}>
      <div className="icon-before icon-caret icon-variant-1" />
      <div className="icon-after icon-caret" />
    </div>
  );
};
export default SliderArrow;
